export default __webpack_public_path__ + "static/image-147-720929b6f36a13d2581c463b3866838d.png";